<template>
  <div class="app">
    <a class="skip-link" href="#main">{{ skipLabel }}</a>
    <SiteHeader />
    <router-view v-slot="{ Component, route }">
      <transition name="page" mode="out-in">
        <main id="main" :key="route.path">
          <component :is="Component" />
        </main>
      </transition>
    </router-view>
    <SiteFooter />
    <WhatsAppButton />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import WhatsAppButton from './components/WhatsAppButton.vue'
import { useLocale } from './composables/useLocale'

const { isAr } = useLocale()
const skipLabel = computed(() => (isAr.value ? 'تخطَّ إلى المحتوى' : 'Skip to content'))
</script>

<style>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app > main {
  flex: 1;
}

.skip-link {
  position: absolute;
  inset-inline-start: 16px;
  top: -60px;
  z-index: 50;
  background: var(--ink);
  color: #fff;
  padding: 10px 18px;
  border-radius: var(--radius-pill);
}

.skip-link:focus {
  top: 12px;
  color: #fff;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
